import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Het spijt ons dat het artikel niet nuttig was. Wilt u ons laten weten wat er mis was?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'De informatie die ik zoek ontbreekt',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Er zijn feitelijke fouten',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Sommige kwesties zijn onduidelijk',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Geef ons wat achtergrondinformatie en we zullen dit artikel verbeteren.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Verzenden'
    }
  }
};